import { API_FEATURE_FLAGS } from '../Redux/Constants/apiUrls';

export const fetchFeatureFlags = async () => {
  const response = await fetch(API_FEATURE_FLAGS, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Feature flags request failed with status ${response.status}`);
  }

  const data = await response.json();
  if (!data || typeof data.features !== 'object' || data.features === null) {
    throw new Error('Feature flags response is missing a valid features object');
  }

  return data.features;
};
